const getFormIdFromTypeformLink = (url: string) => {
  return url.split('/').pop()
}

export { getFormIdFromTypeformLink }
